import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { Invoice } from "@common/types/invoice";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Amount } from "@design-system/Amount/Amount";
import { useAccrualAwareTableMeta } from "@hooks/view/accrualAwareTableMeta";
import { getInvoiceOpenAmount } from "@common/helpers/accrual/openAmount";
import { InvoicesViewCallbacks } from "../types";

export const OpenAmountCell = memo(
    ({ row, table }: CellContext<ViewTableFeatures, Invoice, number>) => {
        const invoice = row.original;
        const { accrualEntityIds, isLoadingAccrualLedgers } =
            useAccrualAwareTableMeta<InvoicesViewCallbacks, Invoice>(table);

        return (
            <ViewTableCell>
                {isLoadingAccrualLedgers ? (
                    "-"
                ) : (
                    <Amount
                        amount={getInvoiceOpenAmount(invoice, accrualEntityIds)}
                    />
                )}
            </ViewTableCell>
        );
    },
);
